import { nodeRedApi } from '../../../services/axios';

const getUnidadesExaustor = async () => {
  try {
    const { data } = await nodeRedApi.get('/exaustor');
    console.log(data);
    return data;
  } catch (error) {
    console.error("Erro na requisição HTTP GET:", error);
    return [];
  }
};

export default getUnidadesExaustor;